import { render, staticRenderFns } from "./feedbackTable.vue?vue&type=template&id=b8ec6418"
import script from "./feedbackTable.vue?vue&type=script&lang=js"
export * from "./feedbackTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports